// Homepage block 最近更新 (D-222): the three newest updates, each linking to its card on /updates.
import { lp, t } from "./i18n";
import { UPDATE_IMAGE_SIZE, liveUpdates, updateImage, useUpdateCopy } from "./updates-copy";
import "./updates-page.css";

export function HomeUpdates() {
  const copy = useUpdateCopy();
  // The simple, everyday wins (entries.json featured), not the newest power features.
  const newest = liveUpdates(copy).filter((entry) => entry.image && entry.featured).slice(0, 3);
  return <section className="home-updates" id="updates" data-home-module="M6-UPDATES" aria-labelledby="home-updates-title">
    <div className="home-updates-head">
      <div><p className="eyebrow">{t("最近更新")}</p><h2 id="home-updates-title">{t("這個月，上課更順手的幾件事")}</h2></div>
      <a href={lp("/updates")} data-cta-position="home_updates_all">{t("看全部更新")} <span aria-hidden="true">→</span></a>
    </div>
    <ul className="home-updates-list">
      {copy && newest.map((entry) => <li key={entry.id}><a href={`${lp("/updates")}#${entry.id}`}>
        <img src={updateImage(entry)!} width={UPDATE_IMAGE_SIZE.width} height={UPDATE_IMAGE_SIZE.height} alt="" loading="lazy" decoding="async" />
        <strong>{copy[entry.id].title}</strong>
        <small>{copy[entry.id].summary}</small>
      </a></li>)}
    </ul>
  </section>;
}
